module.exports = __webpack_public_path__ + "media/images/result_sets/circles/5n6r8n7n-3c184db4693809e9a5276db7136cf40f.svg";